import React, { useState, useEffect } from "react"
import { Layout, Menu, Popover, Select } from 'antd';
import images from '../../themes/appImage'
import { BrowserRouter as Router, Link, useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../../layout/sidebar";
import { Table, Breadcrumb, Modal } from 'antd';
import appconstant from "../../themes/appconstant";
import Textfiled from "../../common";
import ReportPosts from "./ReportPost/ReportPosts";
import ReportPost from "./ReportPost/ReportPost";

const { Header, Content, Footer, Sider } = Layout;

const handleChange = (value) => {
    console.log(`selected ${value}`);
};

const PostReport
    = () => {


        const navigate = useNavigate()
        const { state } = useLocation();
        console.log(state, "this is lod");

        useEffect(() => {
            document.title = 'MentalFit';
        }, [])

        // popover 
        const [open, setOpen] = useState(false);
        const hide = () => {
            setOpen(false);
        };
        const handleOpenChange = (newOpen) => {
            setOpen(newOpen);
        };
        // end popover


        return (
            <div>
                <div className="site-layout-background" style={{ minHeight: 360 }}>

                    <div className="top-header-organi-zations">
                        <div className="organi-zations-heading-text">
                            <h1>Post Report</h1>
                            <p>Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla</p>
                        </div>



                    </div>





                    {/* 
                                <div className="post-rmover-setting">
                                    <div className="post-disp">
                                        <div className="user-pofile">
                                            <img src={images.matleFitLogo} alt="userProf" />
                                        </div>
                                        <div className="user-name">
                                            <h2>MentalFit</h2>
                                            <p>1 hr ago</p>
                                        </div>
                                    </div>
                                </div> */}



                    {/* <div className="user-disp-text">
                                    <p>Sometimes we make the process more complicated than we need to. We will never make a journey of a thousand miles.</p>
                                </div> */}
                    {/* 
                                <div className="post-image">
                                    <img src={images.post} alt="firstIcon" />
                                </div> */}
                    {/* 
                                <div className=" comment-sec">
                                    <div>
                                       
                                    </div>

                                    <div className="like-and-imozes">
                                        <img src={images.commentIcon} alt="commentIcon" />
                                        <img src={images.imozeIcon} alt="imozeIcon" />

                                    </div>
                                </div> */}
                    <ReportPost />



                </div>


                {/* Remove Post */}







            </div>
        )
    }
export default PostReport

